import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const store = (u) => { localStorage.setItem("ct_user", JSON.stringify(u)); window.dispatchEvent(new Event("ct-auth-change")); };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ct_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    if (!localStorage.getItem("ct_token")) return Promise.resolve();
    return api.get("/auth/me").then(({ data }) => { setUser(data); store(data); }).catch(() => setUser(null));
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("ct_token")) { setLoading(false); return; }
    refresh().finally(() => setLoading(false));
    const t = setInterval(refresh, 60000);
    const f = () => refresh();
    window.addEventListener("focus", f);
    return () => { clearInterval(t); window.removeEventListener("focus", f); };
  }, [refresh]);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    localStorage.setItem("ct_token", data.token);
    setUser(data.user); store(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("ct_token");
    localStorage.removeItem("ct_user");
    setUser(null);
    window.dispatchEvent(new Event("ct-auth-change"));
    window.location.href = "/login";
  };

  const perms = user?.permissions || [];
  const can = (p) => !!user?.is_super || perms.includes(p);
  const canAny = (...ps) => ps.some(can);

  return <AuthContext.Provider value={{ user, loading, login, logout, refresh, can, canAny }}>{children}</AuthContext.Provider>;
}
